import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.slice.js";
var BRButton = function BRButton() {
  return import('@/components/atoms/BRButton');
};
var TradeItem = function TradeItem() {
  return import('@/components/atoms/TradeItem');
};
var Trade = function Trade() {
  return import('@/components/templates/Trade');
};
var ModalNew = function ModalNew() {
  return import('@/components/organisms/ModalNew');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
var Pager = function Pager() {
  return import('@/components/atoms/Pager');
};
export default {
  components: {
    BRButton: BRButton,
    TradeItem: TradeItem,
    Trade: Trade,
    ModalNew: ModalNew,
    Modal: Modal,
    RarityIcon: RarityIcon,
    Pager: Pager
  },
  data: function data() {
    return {
      unitPagerName: 'unit',
      sphPagerName: 'sphere',
      tradeType: 0,
      myUnits: [],
      mySpheres: [],
      myAccessories: [],
      myMemorias: [],
      myHeroExpItems: [],
      myLandSectors: [],
      units: [],
      spheres: [],
      accessories: [],
      memorias: [],
      heroExpItems: [],
      landSectors: [],
      isOpenDetail: false,
      selectedTradeId: 0,
      selectedTradeType: 'hero',
      loading: false,
      scrollDisabled: [false, false],
      pages: [0, 0, 0, 0, 0, 0, 0],
      isUnitLoading: false,
      isSphLoading: false,
      isAcceLoading: false,
      isMemoriaLoading: false,
      isHeroExpItemLoading: false,
      isLandSectorLoading: false,
      isFilterModalShown: false,
      isAccessoryFilterModalShown: false,
      defaultFilters: {
        sortId: 1,
        sortOrder: 1,
        status: [],
        rarity: [],
        attribute: []
      },
      selectedFilters: {
        sortId: 1,
        sortOrder: 1,
        status: [],
        rarity: [],
        attribute: []
      },
      sphereFilters: {
        sortId: 1,
        sortOrder: 1,
        status: [],
        rarity: [],
        attribute: []
      },
      acceDefaultFilters: {
        sortId: 1,
        sortOrder: 1,
        status: [],
        rarity: [],
        category: []
      },
      accessoryFilters: {
        sortId: 1,
        sortOrder: 1,
        status: [],
        rarity: [],
        category: []
      },
      memoriaDefaultFilters: {
        sortId: 1,
        sortOrder: 1,
        rarity: [],
        status: [],
        attribute: [],
        memoriaPart: [],
        unitType: []
      },
      memoriaFilters: {
        sortId: 1,
        sortOrder: 1,
        rarity: [],
        status: [],
        attribute: [],
        memoriaPart: [],
        unitType: []
      },
      heroExpItemDefaultFilters: {
        sortId: 1,
        sortOrder: 1,
        status: [],
        attribute: []
      },
      heroExpItemFilters: {
        sortId: 1,
        sortOrder: 1,
        status: [],
        attribute: []
      },
      landSectorDefaultFilters: {
        sortId: 1,
        sortOrder: 1,
        rarity: [],
        status: [],
        attribute: []
      },
      landSectorFilters: {
        sortId: 1,
        sortOrder: 1,
        rarity: [],
        status: [],
        attribute: []
      },
      showUnits: [],
      showSpheres: [],
      showAccessories: [],
      showMemorias: [],
      showHeroExpItems: [],
      showLimit: 42,
      maxUPage: 0,
      maxSPage: 0,
      maxAPage: 0,
      maxMePage: 0,
      maxHPage: 0,
      maxLPage: 0,
      maxTradeRecord: 10000,
      maxPage: 0,
      accessoryCategories: [],
      isLarge: false,
      baseStatus: false
    };
  },
  computed: {
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    getMax: function getMax() {
      return useExtensionStore().getMax;
    },
    TRADE_TYPE: function TRADE_TYPE() {
      return this.$constants.TRADE_TYPE;
    },
    userId: function userId() {
      return useAuthStore().getUserId;
    },
    tradeItemCount: function tradeItemCount() {
      if (this.tradeType == this.TRADE_TYPE.UNIT) return this.units.length;else if (this.tradeType == this.TRADE_TYPE.SPHERE) return this.spheres.length;else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) return this.accessories.length;else if (this.tradeType == this.TRADE_TYPE.MEMORIA) return this.memorias.length;else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) return this.heroExpItems.length;else return 0;
    },
    isLoadMoreDisable: function isLoadMoreDisable() {
      return this.scrollDisabled[this.tradeType];
    },
    attributes: function attributes() {
      return [{
        id: 1,
        name: '~/assets/images/icons/attribute_mark_1_off.png'
      }, {
        id: 2,
        name: '~/assets/images/icons/attribute_mark_2_off.png'
      }, {
        id: 3,
        name: '~/assets/images/icons/attribute_mark_3_off.png'
      }, {
        id: 4,
        name: '~/assets/images/icons/attribute_mark_4_off.png'
      }, {
        id: 5,
        name: '~/assets/images/icons/attribute_mark_5_off.png'
      }, {
        id: 6,
        name: '~/assets/images/icons/attribute_mark_6_off.png'
      }];
    },
    rarities: function rarities() {
      if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) {
        return [{
          id: 5,
          name: 'Legendary'
        }, {
          id: 4,
          name: 'Epic'
        }, {
          id: 2,
          name: 'Uncommon'
        }];
      }
      return [{
        id: 5,
        name: 'Legendary'
      }, {
        id: 4,
        name: 'Epic'
      }, {
        id: 3,
        name: 'Rare'
      }, {
        id: 2,
        name: 'Uncommon'
      }, {
        id: 1,
        name: 'Common'
      }];
    },
    statusList: function statusList() {
      return [{
        id: 1,
        name: this.$t('trade.inTrade')
      }, {
        id: 2,
        name: this.$t('trade.soldOut')
      }, {
        id: 5,
        name: this.$t('trade.inPrepare')
      }, {
        id: 6,
        name: this.$t('trade.inTransaction')
      }];
    },
    memoriaPartList: function memoriaPartList() {
      return [{
        id: 1,
        name: this.$t('trade.avatar')
      }, {
        id: 2,
        name: this.$t('trade.param')
      }, {
        id: 3,
        name: this.$t('trade.bb')
      }];
    },
    unitTypeList: function unitTypeList() {
      return [{
        id: 1,
        name: this.$i18n.locale === 'ja' ? '攻撃' : 'Attack'
      }, {
        id: 2,
        name: this.$i18n.locale === 'ja' ? 'バフ' : 'Buff'
      }, {
        id: 3,
        name: this.$i18n.locale === 'ja' ? 'デバフ' : 'Debuff'
      }, {
        id: 4,
        name: this.$i18n.locale === 'ja' ? '回復' : 'Heal'
      }, {
        id: 5,
        name: this.$i18n.locale === 'ja' ? '挑発' : 'Taunt'
      }];
    },
    heroExpItemAttributeList: function heroExpItemAttributeList() {
      return [{
        id: 1,
        name: this.$i18n.locale === 'ja' ? '紅輝片' : 'Fire Quartz'
      }, {
        id: 2,
        name: this.$i18n.locale === 'ja' ? '蒼輝片' : 'Water Quartz'
      }, {
        id: 3,
        name: this.$i18n.locale === 'ja' ? '翠輝片' : 'Earth Quartz'
      }, {
        id: 4,
        name: this.$i18n.locale === 'ja' ? '金輝片' : 'Thunder Quartz'
      }, {
        id: 5,
        name: this.$i18n.locale === 'ja' ? '聖輝片' : 'Light Quartz'
      }, {
        id: 6,
        name: this.$i18n.locale === 'ja' ? '影輝片' : 'Dark Quartz'
      }, {
        id: 7,
        name: this.$i18n.locale === 'ja' ? '神薙石' : 'Kannagi Stone'
      }];
    },
    sortType: function sortType() {
      return [{
        id: 1,
        name: this.$t('filter.new')
      }, {
        id: 2,
        name: this.$t('filter.price')
      }, {
        id: 4,
        name: this.$t('filter.ce')
      }, {
        id: 6,
        name: this.$t('filter.rarity')
      }, {
        id: 7,
        name: this.$t('filter.lv')
      }, {
        id: 8,
        name: this.$t('filter.hitPoint')
      }, {
        id: 9,
        name: this.$t('filter.AttackPower')
      }, {
        id: 10,
        name: this.$t('filter.magicPower')
      }, {
        id: 11,
        name: this.$t('filter.defense')
      }, {
        id: 12,
        name: this.$t('filter.magicDefense')
      }, {
        id: 13,
        name: this.$t('filter.speed')
      }];
    },
    accessorySortType: function accessorySortType() {
      return [{
        id: 1,
        name: this.$t('filter.new')
      }, {
        id: 2,
        name: this.$t('filter.price')
      }, {
        id: 3,
        name: this.$t('filter.rarity')
      }, {
        id: 4,
        name: this.$t('filter.category')
      }];
    },
    memoriaSortType: function memoriaSortType() {
      return [{
        id: 1,
        name: this.$t('filter.new')
      }, {
        id: 2,
        name: this.$t('filter.price')
      }, {
        id: 6,
        name: this.$t('filter.rarity')
      }, {
        id: 8,
        name: this.$t('filter.hitPoint')
      }, {
        id: 9,
        name: this.$t('filter.AttackPower')
      }, {
        id: 10,
        name: this.$t('filter.magicPower')
      }, {
        id: 11,
        name: this.$t('filter.defense')
      }, {
        id: 12,
        name: this.$t('filter.magicDefense')
      }, {
        id: 13,
        name: this.$t('filter.speed')
      }];
    },
    heroExpItemSortType: function heroExpItemSortType() {
      return [{
        id: 1,
        name: this.$t('filter.new')
      }, {
        id: 2,
        name: this.$t('filter.price')
      }];
    },
    landSectorSortType: function landSectorSortType() {
      return [{
        id: 1,
        name: this.$t('filter.new')
      }, {
        id: 2,
        name: this.$t('filter.price')
      }, {
        id: 6,
        name: this.$t('filter.rarity')
      }];
    },
    maxUnitPage: function maxUnitPage() {
      return this.maxUPage;
    },
    maxSphPage: function maxSphPage() {
      return this.maxSPage;
    },
    maxAccePage: function maxAccePage() {
      return this.maxAPage;
    },
    maxMemoriaPage: function maxMemoriaPage() {
      return this.maxMePage;
    },
    maxHeroExpItemPage: function maxHeroExpItemPage() {
      return this.maxHPage;
    },
    maxLandSectorPage: function maxLandSectorPage() {
      return this.maxLPage;
    },
    isTradeAssets: function isTradeAssets() {
      return this.tradeType != this.TRADE_TYPE.IN_TRADE;
    },
    tradeCounts: function tradeCounts() {
      if (this.tradeType == this.TRADE_TYPE.UNIT) return this.units.length;else if (this.tradeType == this.TRADE_TYPE.SPHERE) return this.spheres.length;else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) return this.accessories.length;else if (this.tradeType == this.TRADE_TYPE.MEMORIA) return this.memorias.length;else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) return this.heroExpItems.length;else if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) return this.landSectors.length;
    },
    endPage: function endPage() {
      if (this.tradeType == this.TRADE_TYPE.UNIT) {
        return this.maxUnitPage - 1;
      } else if (this.tradeType == this.TRADE_TYPE.SPHERE) {
        return this.maxSphPage - 1;
      } else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) {
        return this.maxAccePage - 1;
      } else if (this.tradeType == this.TRADE_TYPE.MEMORIA) {
        return this.maxMemoriaPage - 1;
      } else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) {
        return this.maxHeroExpItemPage - 1;
      } else if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) {
        return this.maxLandSectorPage - 1;
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, heroes, extensions, accessories, memorias, heroExpItems, landSectors, heroIds, sphIds;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.loading = true;
            _context.next = 3;
            return _this.$accessoryService.getAccessoryCategories();
          case 3:
            _this.accessoryCategories = _context.sent;
            _this.initSortAndFilter();
            _context.next = 7;
            return _this.refreshTradeData();
          case 7:
            _context.next = 9;
            return Promise.all([_this.$tradesService.getUidHeroTrade(_this.userId), _this.$tradesService.getUidExtensionTrade(_this.userId), _this.$tradesService.getUidAccessoryTrade(_this.userId), _this.$tradesService.getUidMemoriaTrade(_this.userId), _this.$tradesService.getUidHeroExpItemTrade(_this.userId), _this.$tradesService.getUidLandSectorTrade(_this.userId)]);
          case 9:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 6);
            heroes = _yield$Promise$all2[0];
            extensions = _yield$Promise$all2[1];
            accessories = _yield$Promise$all2[2];
            memorias = _yield$Promise$all2[3];
            heroExpItems = _yield$Promise$all2[4];
            landSectors = _yield$Promise$all2[5];
            heroIds = heroes.map(function (hero) {
              return hero.heroId;
            });
            sphIds = extensions.map(function (sphere) {
              return sphere.extensionId;
            });
            _context.next = 21;
            return Promise.all([_this.fetchHeroes(heroIds), _this.fetchExtensions(sphIds)]);
          case 21:
            _this.myUnits = heroes;
            _this.mySpheres = extensions;
            _this.myAccessories = accessories;
            _this.myMemorias = memorias;
            _this.myHeroExpItems = heroExpItems;
            _this.myLandSectors = landSectors;
            _this.loading = false;
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchHeroes: function fetchHeroes(ids) {
      return useHeroStore().fetchHeroes(ids);
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    changeTradeType: function changeTradeType(typ) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.pages[_this2.TRADE_TYPE.UNIT] = 0;
              _this2.pages[_this2.TRADE_TYPE.SPHERE] = 0;
              _this2.pages[_this2.TRADE_TYPE.ACCESSORY] = 0;
              _this2.pages[_this2.TRADE_TYPE.MEMORIA] = 0;
              _this2.pages[_this2.TRADE_TYPE.HERO_EXP_ITEM] = 0;
              _this2.pages[_this2.TRADE_TYPE.LAND_SECTOR] = 0;
              _this2.isUnitLoading = false;
              _this2.isSphLoading = false;
              _this2.isAcceLoading = false;
              _this2.isMemoriaLoading = false;
              _this2.isHeroExpItemLoading = false;
              _this2.isLandSectorLoading = false;
              _this2.loading = true;
              _this2.tradeType = typ;
              if (!(typ < 3 || typ > 3)) {
                _context2.next = 17;
                break;
              }
              _context2.next = 17;
              return _this2.loadMore();
            case 17:
              _this2.loading = false;
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onTradeDetail: function onTradeDetail(_ref) {
      var id = _ref.id,
        type = _ref.type;
      this.selectedTradeId = id;
      this.selectedTradeType = type;
      this.isOpenDetail = true;
    },
    onCloseTradeDetail: function onCloseTradeDetail() {
      this.isOpenDetail = false;
      this.selectedTradeId = 0;
      this.selectedTradeType = '';
    },
    onCloseTradeDetailAndRefresh: function onCloseTradeDetailAndRefresh() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isOpenDetail = false;
              _this3.selectedTradeId = 0;
              _this3.selectedTradeType = '';
              _context3.next = 5;
              return _this3.onSNFChange();
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getPager: function getPager(tradeType) {
      var pgrName = 'unit';
      if (tradeType == this.TRADE_TYPE.SPHERE) pgrName = 'sphere';
      if (tradeType == this.TRADE_TYPE.ACCESSORY) pgrName = 'accessory';
      if (tradeType == this.TRADE_TYPE.MEMORIA) pgrName = 'memoria';
      if (tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) pgrName = 'heroExpItem';
      if (tradeType == this.TRADE_TYPE.LAND_SECTOR) pgrName = 'landSector';
      return this.$children.find(function (x) {
        return x.name === pgrName;
      });
    },
    onPage: function onPage(data) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var originalPage, pgr;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              originalPage = _this4.pages[_this4.tradeType];
              if (!(!data.skip && !_this4.canPageExecute(data.direction))) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              _context4.prev = 3;
              if (data.skip) {
                _this4.pages[_this4.tradeType] = data.direction;
              } else {
                _this4.pages[_this4.tradeType] += data.direction;
              }
              _context4.next = 7;
              return _this4.loadMore();
            case 7:
              pgr = _this4.getPager(_this4.tradeType);
              if (pgr) pgr.updateIdx(data.direction);
              _context4.next = 16;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](3);
              // 戻し
              _this4.pages[_this4.tradeType] = originalPage;
              _context4.next = 16;
              return _this4.loadMore();
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 11]]);
      }))();
    },
    canPageExecute: function canPageExecute(num) {
      var active = this.pages[this.tradeType] + 1;
      if (num > 0) {
        return this.tradeType == this.TRADE_TYPE.UNIT && active != this.maxUnitPage || this.tradeType == this.TRADE_TYPE.SPHERE && active != this.maxSphPage || this.tradeType == this.TRADE_TYPE.ACCESSORY && active != this.maxAccePage || this.tradeType == this.TRADE_TYPE.MEMORIA && active != this.maxMemoriaPage || this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM && active != this.maxHeroExpItemPage || this.tradeType == this.TRADE_TYPE.LAND_SECTOR && active != this.maxLandSectorPage;
      } else {
        return active > 1;
      }
    },
    onSNFChange: function onSNFChange() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _this5.isFilterModalShown = false;
              _this5.isAccessoryFilterModalShown = false;
              _this5.loading = true;
              _context5.next = 6;
              return _this5.refreshTradeData();
            case 6:
              _context5.next = 8;
              return _this5.changeTradeType(_this5.tradeType);
            case 8:
              _this5.loading = false;

              // 通信成功したら保存する
              if (_this5.tradeType == _this5.TRADE_TYPE.UNIT) {
                _this5.$localStorage.set('bfh:tradeSortAndfilter', JSON.stringify(_this5.selectedFilters));
              } else if (_this5.tradeType == _this5.TRADE_TYPE.SPHERE) {
                _this5.$localStorage.set('bfh:tradeSortAndfilterSphere', JSON.stringify(_this5.sphereFilters));
              } else if (_this5.tradeType == _this5.TRADE_TYPE.ACCESSORY) {
                _this5.$localStorage.set('bfh:tradeSortAndfilterAccessory', JSON.stringify(_this5.accessoryFilters));
              } else if (_this5.tradeType == _this5.TRADE_TYPE.MEMORIA) {
                _this5.$localStorage.set('bfh:tradeSortAndfilterMemoria', JSON.stringify(_this5.memoriaFilters));
              } else if (_this5.tradeType == _this5.TRADE_TYPE.HERO_EXP_ITEM) {
                _this5.$localStorage.set('bfh:tradeSortAndfilterHeroExpItem', JSON.stringify(_this5.heroExpItemFilters));
              } else if (_this5.tradeType == _this5.TRADE_TYPE.LAND_SECTOR) {
                _this5.$localStorage.set('bfh:tradeSortAndfilterLandSector', JSON.stringify(_this5.landSectorFilters));
              }
              _context5.next = 15;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](0);
              _this5.loading = false;
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 12]]);
      }))();
    },
    changeOrder: function changeOrder() {
      var usingFilter = this.selectedFilters;
      if (this.tradeType == this.TRADE_TYPE.SPHERE) usingFilter = this.sphereFilters;else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) usingFilter = this.accessoryFilters;else if (this.tradeType == this.TRADE_TYPE.MEMORIA) usingFilter = this.memoriaFilters;else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) usingFilter = this.heroExpItemFilters;else if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) usingFilter = this.landSectorFilters;
      usingFilter.sortOrder = 1 - usingFilter.sortOrder;
    },
    toggleFilter: function toggleFilter(category) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var usingFilter = this.selectedFilters;
      if (this.tradeType == this.TRADE_TYPE.SPHERE) usingFilter = this.sphereFilters;else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) usingFilter = this.accessoryFilters;else if (this.tradeType == this.TRADE_TYPE.MEMORIA) usingFilter = this.memoriaFilters;else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) usingFilter = this.heroExpItemFilters;else if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) usingFilter = this.landSectorFilters;
      if (usingFilter[category].includes(id)) {
        var index = usingFilter[category].indexOf(id);
        usingFilter[category].splice(index, 1);
      } else {
        usingFilter[category].push(id);
      }
    },
    initSortAndFilter: function initSortAndFilter() {
      // ソートフィルター情報が保存されていれば取得
      // Unit
      if (this.$localStorage.get('bfh:tradeSortAndfilter') != null && this.$localStorage.get('bfh:tradeSortAndfilter') != 'undefined') {
        this.selectedFilters = JSON.parse(this.$localStorage.get('bfh:tradeSortAndfilter'));
      } else {
        this.selectedFilters = this.$util.clone(this.defaultFilters);
      }
      // Sphere
      if (this.$localStorage.get('bfh:tradeSortAndfilterSphere') != null && this.$localStorage.get('bfh:tradeSortAndfilterSphere') != 'undefined') {
        this.sphereFilters = JSON.parse(this.$localStorage.get('bfh:tradeSortAndfilterSphere'));
      } else {
        this.sphereFilters = this.$util.clone(this.defaultFilters);
      }
      // accessory
      if (this.$localStorage.get('bfh:tradeSortAndfilterAccessory') != null && this.$localStorage.get('bfh:tradeSortAndfilterAccessory') != 'undefined') {
        this.accessoryFilters = JSON.parse(this.$localStorage.get('bfh:tradeSortAndfilterAccessory'));
      } else {
        this.accessoryFilters = this.$util.clone(this.acceDefaultFilters);
      }
      // memoria
      if (this.$localStorage.get('bfh:tradeSortAndfilterMemoria') != null && this.$localStorage.get('bfh:tradeSortAndfilterMemoria') != 'undefined') {
        this.memoriaFilters = JSON.parse(this.$localStorage.get('bfh:tradeSortAndfilterMemoria'));
      } else {
        this.memoriaFilters = this.$util.clone(this.memoriaDefaultFilters);
      }
      // heroExpItem
      if (this.$localStorage.get('bfh:tradeSortAndfilterHeroExpItem') != null && this.$localStorage.get('bfh:tradeSortAndfilterHeroExpItem') != 'undefined') {
        this.heroExpItemFilters = JSON.parse(this.$localStorage.get('bfh:tradeSortAndfilterHeroExpItem'));
      } else {
        this.heroExpItemFilters = this.$util.clone(this.heroExpItemDefaultFilters);
      }
      // LandSector
      if (this.$localStorage.get('bfh:tradeSortAndfilterLandSector') != null && this.$localStorage.get('bfh:tradeSortAndfilterLandSector') != 'undefined') {
        this.landSectorFilters = JSON.parse(this.$localStorage.get('bfh:tradeSortAndfilterLandSector'));
      } else {
        this.landSectorFilters = this.$util.clone(this.landSectorDefaultFilters);
      }
    },
    clearFilter: function clearFilter() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (_this6.tradeType == _this6.TRADE_TYPE.UNIT) _this6.selectedFilters = _this6.$util.clone(_this6.defaultFilters);else if (_this6.tradeType == _this6.TRADE_TYPE.SPHERE) _this6.sphereFilters = _this6.$util.clone(_this6.defaultFilters);else if (_this6.tradeType == _this6.TRADE_TYPE.ACCESSORY) _this6.accessoryFilters = _this6.$util.clone(_this6.acceDefaultFilters);else if (_this6.tradeType == _this6.TRADE_TYPE.MEMORIA) _this6.memoriaFilters = _this6.$util.clone(_this6.memoriaDefaultFilters);else if (_this6.tradeType == _this6.TRADE_TYPE.HERO_EXP_ITEM) _this6.heroExpItemFilters = _this6.$util.clone(_this6.heroExpItemDefaultFilters);else if (_this6.tradeType == _this6.TRADE_TYPE.LAND_SECTOR) _this6.landSectorFilters = _this6.$util.clone(_this6.landSectorDefaultFilters);
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getAttributeImgSrc: function getAttributeImgSrc(id) {
      var src = '';
      if (this.isSelected('attribute', id)) {
        src = require('~/assets/images/icons/attribute_mark_' + String(id) + '_on.png');
      } else {
        src = require('~/assets/images/icons/attribute_mark_' + String(id) + '_off.png');
      }
      return src;
    },
    isSelected: function isSelected(category) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var usingFilter = this.selectedFilters;
      if (this.tradeType == this.TRADE_TYPE.SPHERE) usingFilter = this.sphereFilters;else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) usingFilter = this.accessoryFilters;else if (this.tradeType == this.TRADE_TYPE.MEMORIA) usingFilter = this.memoriaFilters;else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) usingFilter = this.heroExpItemFilters;else if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) usingFilter = this.landSectorFilters;
      var filteredCategory = usingFilter[category] || [];
      return filteredCategory.includes(id);
    },
    refreshTradeData: function refreshTradeData() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$Promise$all3, _yield$Promise$all4, units, spheres, accessories, memorias, heroExpItems, landSectors, unitIds, sphereIds, upgr, spgr, apgr, mepgr, hpgr, lpgr;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return Promise.all([_this7.$tradesService.getHeroTrade(_this7.maxTradeRecord, 0, _this7.selectedFilters), _this7.$tradesService.getExtensionTrade(_this7.maxTradeRecord, 0, _this7.sphereFilters), _this7.$tradesService.getAccessoryTrade(_this7.maxTradeRecord, 0, _this7.accessoryFilters), _this7.$tradesService.getMemoriaTrade(_this7.maxTradeRecord, 0, _this7.memoriaFilters), _this7.$tradesService.getHeroExpItemTrade(_this7.maxTradeRecord, 0, _this7.heroExpItemFilters), _this7.$tradesService.getLandSectorTrade(_this7.maxTradeRecord, 0, _this7.landSectorFilters)]);
            case 2:
              _yield$Promise$all3 = _context7.sent;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 6);
              units = _yield$Promise$all4[0];
              spheres = _yield$Promise$all4[1];
              accessories = _yield$Promise$all4[2];
              memorias = _yield$Promise$all4[3];
              heroExpItems = _yield$Promise$all4[4];
              landSectors = _yield$Promise$all4[5];
              _this7.units = units;
              _this7.spheres = spheres;
              _this7.accessories = accessories;
              _this7.memorias = memorias;
              _this7.heroExpItems = heroExpItems;
              _this7.landSectors = landSectors;

              // 表示用Limitまで切り出す
              _this7.showUnits = _this7.units.slice(0, _this7.showLimit);
              _this7.showSpheres = _this7.spheres.slice(0, _this7.showLimit);
              _this7.showAccessories = _this7.accessories.slice(0, _this7.showLimit);
              _this7.showMemorias = _this7.memorias.slice(0, _this7.showLimit);
              _this7.showHeroExpItems = _this7.heroExpItems.slice(0, _this7.showLimit);
              _this7.showLandSectors = _this7.landSectors.slice(0, _this7.showLimit);

              // IDリストに変更
              unitIds = _this7.showUnits.map(function (unit) {
                return unit.heroId;
              });
              sphereIds = _this7.showSpheres.map(function (sph) {
                return sph.extensionId;
              }); // 情報取得
              _context7.next = 26;
              return _this7.fetchHeroes(unitIds);
            case 26:
              _context7.next = 28;
              return _this7.fetchExtensions(sphereIds);
            case 28:
              _this7.maxUPage = Math.ceil(_this7.units.length / _this7.showLimit);
              _this7.maxSPage = Math.ceil(_this7.spheres.length / _this7.showLimit);
              _this7.maxAPage = Math.ceil(_this7.accessories.length / _this7.showLimit);
              _this7.maxMePage = Math.ceil(_this7.memorias.length / _this7.showLimit);
              _this7.maxHPage = Math.ceil(_this7.heroExpItems.length / _this7.showLimit);
              _this7.maxLPage = Math.ceil(_this7.landSectors.length / _this7.showLimit);
              upgr = _this7.getPager(_this7.TRADE_TYPE.UNIT);
              if (upgr) upgr.reset();
              spgr = _this7.getPager(_this7.TRADE_TYPE.SPHERE);
              if (spgr) spgr.reset();
              apgr = _this7.getPager(_this7.TRADE_TYPE.ACCESSORY);
              if (apgr) apgr.reset();
              mepgr = _this7.getPager(_this7.TRADE_TYPE.MEMORIA);
              if (mepgr) mepgr.reset();
              hpgr = _this7.getPager(_this7.TRADE_TYPE.HERO_EXP_ITEM);
              if (hpgr) hpgr.reset();
              lpgr = _this7.getPager(_this7.TRADE_TYPE.LAND_SECTOR);
              if (lpgr) lpgr.reset();
            case 46:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    loadMore: function loadMore() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var unitOffset, unitEndIndex, unitIds, sphOffset, sphEndIndex, sphIds, offset, endIndex, memoriaOffset, memoriaEndIndex, heroExpItemOffset, heroExpItemEndIndex, landSectorOffset, landSectorEndIndex;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.t0 = _this8.tradeType;
              _context8.next = _context8.t0 === _this8.TRADE_TYPE.UNIT ? 3 : _context8.t0 === _this8.TRADE_TYPE.SPHERE ? 15 : _context8.t0 === _this8.TRADE_TYPE.ACCESSORY ? 27 : _context8.t0 === _this8.TRADE_TYPE.MEMORIA ? 36 : _context8.t0 === _this8.TRADE_TYPE.HERO_EXP_ITEM ? 45 : _context8.t0 === _this8.TRADE_TYPE.LAND_SECTOR ? 54 : 63;
              break;
            case 3:
              if (!_this8.isUnitLoading) {
                _context8.next = 5;
                break;
              }
              return _context8.abrupt("return");
            case 5:
              _this8.showUnits = [];
              _this8.isUnitLoading = true;
              unitOffset = _this8.pages[0] * _this8.showLimit;
              unitEndIndex = unitOffset + _this8.showLimit;
              _this8.showUnits = _this8.units.slice(unitOffset, unitEndIndex);
              unitIds = _this8.showUnits.map(function (unit) {
                return unit.heroId;
              });
              _context8.next = 13;
              return _this8.fetchHeroes(unitIds);
            case 13:
              _this8.isUnitLoading = false;
              return _context8.abrupt("break", 64);
            case 15:
              if (!_this8.isSphLoading) {
                _context8.next = 17;
                break;
              }
              return _context8.abrupt("return");
            case 17:
              _this8.showSpheres = [];
              _this8.isSphLoading = true;
              sphOffset = _this8.pages[1] * _this8.showLimit;
              sphEndIndex = sphOffset + _this8.showLimit;
              _this8.showSpheres = _this8.spheres.slice(sphOffset, sphEndIndex);
              sphIds = _this8.showSpheres.map(function (sph) {
                return sph.extensionId;
              });
              _context8.next = 25;
              return _this8.fetchExtensions(sphIds);
            case 25:
              _this8.isSphLoading = false;
              return _context8.abrupt("break", 64);
            case 27:
              if (!_this8.isAcceLoading) {
                _context8.next = 29;
                break;
              }
              return _context8.abrupt("return");
            case 29:
              _this8.showAccessories = [];
              _this8.isAcceLoading = true;
              offset = _this8.pages[2] * _this8.showLimit;
              endIndex = offset + _this8.showLimit;
              _this8.showAccessories = _this8.accessories.slice(offset, endIndex);
              _this8.isAcceLoading = false;
              return _context8.abrupt("break", 64);
            case 36:
              if (!_this8.isMemoriaLoading) {
                _context8.next = 38;
                break;
              }
              return _context8.abrupt("return");
            case 38:
              _this8.showMemorias = [];
              _this8.isMemoriaLoading = true;
              memoriaOffset = _this8.pages[4] * _this8.showLimit;
              memoriaEndIndex = memoriaOffset + _this8.showLimit;
              _this8.showMemorias = _this8.memorias.slice(memoriaOffset, memoriaEndIndex);
              _this8.isMemoriaLoading = false;
              return _context8.abrupt("break", 64);
            case 45:
              if (!_this8.isHeroExpItemLoading) {
                _context8.next = 47;
                break;
              }
              return _context8.abrupt("return");
            case 47:
              _this8.showHeroExpItems = [];
              _this8.isHeroExpItemLoading = true;
              heroExpItemOffset = _this8.pages[5] * _this8.showLimit;
              heroExpItemEndIndex = heroExpItemOffset + _this8.showLimit;
              _this8.showHeroExpItems = _this8.heroExpItems.slice(heroExpItemOffset, heroExpItemEndIndex);
              _this8.isHeroExpItemLoading = false;
              return _context8.abrupt("break", 64);
            case 54:
              if (!_this8.isLandSectorLoading) {
                _context8.next = 56;
                break;
              }
              return _context8.abrupt("return");
            case 56:
              _this8.showLandSectors = [];
              _this8.isLandSectorLoading = true;
              landSectorOffset = _this8.pages[6] * _this8.showLimit;
              landSectorEndIndex = landSectorOffset + _this8.showLimit;
              _this8.showLandSectors = _this8.landSectors.slice(landSectorOffset, landSectorEndIndex);
              _this8.isLandSectorLoading = false;
              return _context8.abrupt("break", 64);
            case 63:
              return _context8.abrupt("break", 64);
            case 64:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getPageCount: function getPageCount() {
      if (this.tradeType == this.TRADE_TYPE.UNIT) {
        this.maxPage = this.maxUnitPage;
      } else if (this.tradeType == this.TRADE_TYPE.SPHERE) {
        this.maxPage = this.maxSphPage;
      } else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) {
        this.maxPage = this.maxAccePage;
      } else if (this.tradeType == this.TRADE_TYPE.MEMORIA) {
        this.maxPage = this.maxMemoriaPage;
      } else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) {
        this.maxPage = this.maxHeroExpItemPage;
      } else if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) {
        this.maxPage = this.maxLandSectorPage;
      }
      if (this.maxPage <= 5) return this.maxPage;
      if (this.pages[this.tradeType] >= 3) {
        var dispMinPage = this.pages[this.tradeType] - 1;
        if (dispMinPage + 4 >= this.maxPage) {
          dispMinPage = this.maxPage - 4;
        }
        var pageArray = [];
        for (var i = dispMinPage; i <= dispMinPage + 4; i++) {
          pageArray.push(i);
        }
        return pageArray;
      }
      return 5;
    },
    getDisplayCount: function getDisplayCount() {
      var page = this.pages[this.tradeType] + 1;
      if (page != this.maxPage) {
        return (page - 1) * this.showLimit + this.showLimit;
      } else {
        if (this.tradeType == this.TRADE_TYPE.UNIT) {
          return this.units.length;
        } else if (this.tradeType == this.TRADE_TYPE.SPHERE) {
          return this.spheres.length;
        } else if (this.tradeType == this.TRADE_TYPE.ACCESSORY) {
          return this.accessories.length;
        } else if (this.tradeType == this.TRADE_TYPE.MEMORIA) {
          return this.memorias.length;
        } else if (this.tradeType == this.TRADE_TYPE.HERO_EXP_ITEM) {
          return this.heroExpItems.length;
        } else if (this.tradeType == this.TRADE_TYPE.LAND_SECTOR) {
          return this.landSectors.length;
        }
      }
    }
  }
};